import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import { isEqual } from "@utils/lodash";
import Utils from "@utils";
import ReportsTable from "./components/ReportsTable";
import { paymentReportsColumn, reportsJobColumn } from "./utils/columnsDefinition";

class PaymentHistoryReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rateStats: this.processRateStatusData(props.data || {}),
			jobData: this.processJobData(props.data.JobPaymentSummaries || []),
		};
	}

	componentDidUpdate({ data: prevData }) {
		const { data } = this.props;
		if (!isEqual(prevData, data)) {
			// This ESLint rule could possibly be disabled permanently. Further di scussions will be necessary, but disabling in this file for right now
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({
				rateStats: this.processRateStatusData(data),
				jobData: this.processJobData(data.JobPaymentSummaries),
			});
		}
	}

	processRateStatusData = rawData => {
		const { lang } = global;
		const { isCoordinator } = rawData;
		const { user } = this.props;
		return [
			{
				id: 1,
				label: lang.t("Total Paid"),
				value: rawData.TotalPaid,
			},
			{
				id: 2,
				label: lang.t(
					isCoordinator || user.IsInternalCoordinator
						? "Total Officer Pay"
						: "Total Fees Paid",
				),
				value:
					isCoordinator || user.IsInternalCoordinator
						? rawData.TotalPaidToOfficers
						: rawData.TotalJurisdictionFees,
			},
			{
				id: 3,
				label: lang.t(
					isCoordinator || user.IsInternalCoordinator
						? "Total Coordination Fees"
						: "Total Officer Pay",
				),
				value:
					isCoordinator || user.IsInternalCoordinator
						? rawData.TotalPaidToCoordinators
						: rawData.TotalPaidToOfficers,
			},
		];
	};

	processJobData = rawJobData => {
		if (!(rawJobData instanceof Array)) return [];
		const jobSummary = [...rawJobData];
		if (jobSummary.length) {
			jobSummary.map(item => {
				const statusObj = Utils.getNewJobStatus(item);
				return { ...item, statusObj };
			});
		}
		return jobSummary;
	};

	renderRateStats = rateStats => {
		const { lang } = global;
		return (
			<div>
				<Row className="padding-top-20 hidden-print">
					<For
						each="item"
						of={rateStats}
					>
						<Col
							key={item.id}
							md={4}
							xs={4}
						>
							<div className="bg-white padding-15 rate-stats-upper-border rate-stats-bottom-border">
								<span className="rate-stats-label">{item.label}</span>
								<p className="rate-stats-value">
									{Utils.currencyFormatter(item.value)}
								</p>
							</div>
						</Col>
					</For>
				</Row>
				<Row className="visible-print margin-left-1">
					<div className="margin-top-10">
						<span className="color-dark font-regular report-table-header-title">
							{lang.t("Payment Summary")}
						</span>
					</div>
					<For
						each="item"
						of={rateStats}
					>
						<div
							key={item.id}
							className="flex"
						>
							<span className="font-light color-blue-bayoux flex-1">
								{item.label}
							</span>
							<span className="font-regular color-blue-bayoux flex-2">
								:{Utils.currencyFormatter(item.value)}
							</span>
						</div>
					</For>
				</Row>
			</div>
		);
	};

	render() {
		const { lang } = global;
		const { rateStats, jobData } = this.state;
		const { data, user } = this.props;

		return (
			<div className="panel reports-panel">
				<div className="panel-content">
					{this.renderRateStats(rateStats)}
					<ReportsTable
						header={lang.t("Client")}
						data={data.ClientPaymentSummaries || []}
						tableColumn={paymentReportsColumn("Client")}
					/>
					<If condition={data.isLEA && user.IsStaffAdmin}>
						<ReportsTable
							header={`${lang.t("Coordinator")} ${lang.t("Fees")}`}
							data={data.SupervisorPaymentSummaries || []}
							tableColumn={paymentReportsColumn("Coordinator")}
						/>
					</If>
					<ReportsTable
						header={lang.t("Locations")}
						data={data.LocationPaymentSummaries || []}
						tableColumn={paymentReportsColumn("Location")}
					/>
					<ReportsTable
						header={lang.t("Jurisdiction Fees")}
						data={data.JurisdictionFeesPaymentSummaries || []}
						tableColumn={paymentReportsColumn("Jurisdiction")}
					/>
					<ReportsTable
						header={lang.t("Fee Type Payment Summary")}
						data={data.FeeTypePaymentSummaries || []}
						tableColumn={paymentReportsColumn("Fee")}
					/>
					<ReportsTable
						header={lang.t("Officers")}
						data={data.OfficerPaymentSummaries || []}
						tableColumn={paymentReportsColumn("Officer")}
					/>
					<ReportsTable
						header={lang.t("Invoices")}
						data={jobData}
						tableColumn={reportsJobColumn("paymentHistory", user.TimeZoneId, user)}
					/>
				</div>
			</div>
		);
	}
}

PaymentHistoryReport.propTypes = {
	user: PropTypes.object,
	data: PropTypes.object,
};

PaymentHistoryReport.defaultProps = {
	user: {},
	data: {},
};

export default PaymentHistoryReport;
